/**
 * HTML Entity specific types
 * Based on data model from specs/003-encoders-decoders-tools/data-model.md
 */

export const HtmlEntityMode = {
  ENCODE: 'encode',
  DECODE: 'decode',
  Html4: 'html4',
  Html5: 'html5',
  Xml: 'xml',
  Numeric: 'numeric'
} as const;

export type HtmlEntityMode = typeof HtmlEntityMode[keyof typeof HtmlEntityMode];

export interface HtmlEntityConfiguration {
  input: string;
  mode: HtmlEntityMode;
  encodeSpaces?: boolean;
  encodeAllChars?: boolean;
  preserveLineBreaks?: boolean;
  customEntities?: Record<string, string>;
}